import React from 'react';

interface TwoItemsRowProps {
  firstComponent: React.ReactNode;
  secondComponent: React.ReactNode;
}

const TwoItemsRow: React.FC<TwoItemsRowProps> = (props) => {
  const { firstComponent, secondComponent } = props;
  return (
    <div className={'row'}>
      <div className={'col'}>{firstComponent}</div>
      <div className={'col'}>{secondComponent}</div>
    </div>
  );
};

export default TwoItemsRow;
